import React, { useState } from "react";
import { useLoader } from "../../../context/LoaderContext";
import axios from "axios";
import { headers } from "../../../exports/exports";
import { dynamicFailed, dynamicSuccess } from "../../../hooks/useToast";
import { countryDetails } from "../../../exports/countrydetails";
import { sendErrorLog } from "../../ErrorLog";

interface ContactInformationProps {
  mobilenumber: string;
  setMobileNumber: React.Dispatch<React.SetStateAction<string>>;

  whatsappnumber: string;
  setWhatsappNumber: React.Dispatch<React.SetStateAction<string>>;

  permanentAddress: string;
  setPermanentAddress: React.Dispatch<React.SetStateAction<string>>;

  city: string;
  setCity: React.Dispatch<React.SetStateAction<string>>;

  stateProvince: string;
  setStateProvince: React.Dispatch<React.SetStateAction<string>>;

  postalZipCode: number | null;
  setPostalZipCode: React.Dispatch<React.SetStateAction<number | null>>;

  country: string;
  setCountry: React.Dispatch<React.SetStateAction<string>>;

  workAddress: string;
  setWorkAddress: React.Dispatch<React.SetStateAction<string>>;

  workCity: string;
  setWorkCity: React.Dispatch<React.SetStateAction<string>>;

  workStateProvince: string;
  setWorkStateProvince: React.Dispatch<React.SetStateAction<string>>;

  workPostalZipCode: number | null;
  setWorkPostalZipCode: React.Dispatch<React.SetStateAction<number | null>>;

  workCountry: string;
  setWorkCountry: React.Dispatch<React.SetStateAction<string>>;

  memberId: number;
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  mobilenumber,
  setMobileNumber,
  whatsappnumber,
  setWhatsappNumber,
  permanentAddress,
  setPermanentAddress,
  city,
  setCity,
  stateProvince,
  setStateProvince,
  postalZipCode,
  setPostalZipCode,
  country,
  setCountry,
  workAddress,
  setWorkAddress,
  workCity,
  setWorkCity,
  workStateProvince,
  setWorkStateProvince,
  workPostalZipCode,
  setWorkPostalZipCode,
  workCountry,
  setWorkCountry,
  memberId,
}) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { setLoading } = useLoader();
  const [openAccordion, setOpenAccordion] = useState<
    "permanent" | "work" | null
  >("permanent");
  const toggleAccordion = (section: "permanent" | "work") => {
    setOpenAccordion((prev) => (prev === section ? null : section));
  };
  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    if (!mobilenumber) {
      newErrors.mobilenumber = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(mobilenumber)) {
      newErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
    }

    if (!permanentAddress)
      newErrors.permanentAddress = "Permanent Address is required";

    if (!city) newErrors.city = "City is required";
    if (!stateProvince) newErrors.stateProvince = "State/Province is required";

    if (!postalZipCode) newErrors.postalZipCode = "Postal/Zip Code is required";
    else if (postalZipCode.toString().length < 4)
      newErrors.postalZipCode =
        "Postal/Zip Code must be at least 4 digits long";

    if (!country) newErrors.country = "Country is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const data = {
        data: {
          Mobile_Number: mobilenumber,
          WhatsAPP_Number: whatsappnumber,
          Permanent_Address: permanentAddress,
          City: city,
          State_Province: stateProvince,
          Postal_Zip_Code: postalZipCode,
          Country: country,
          Work_Address: workAddress,
          Work_City: workCity,
          Work_State_Province: workStateProvince,
          Work_Postal_Zip_Code: workPostalZipCode,
          Work_Country: workCountry,
        },
      };
      axios
        .put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberId}`,
          data,
          {
            headers: headers,
          },
        )
        .then(() => {
          dynamicSuccess("Profile updated successfully!");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(async (e: any) => {
          await sendErrorLog(
            "User Update Error",
            "",
            "",
            mobilenumber,
            e?.config?.url,
            e.message,
          );
          dynamicFailed(`${e.message}`);
          setLoading(false);
        });
    } catch (e: any) {
      await sendErrorLog(
        "User Update Error",
        "",
        "",
        mobilenumber,
        e?.config?.url,
        e.message,
      );
      dynamicFailed(`${e.message}`);
      setLoading(false);
    }
  };
  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Contact Information</h3>
          <p className="user-card__designation">
            Update your contact informaiton
          </p>
        </div>
      </div>
      <hr />
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="Mobile Number*"
            name="mobilenumber"
            value={mobilenumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            className={errors.mobilenumber && "error-border"}
          />
          {errors.mobilenumber && (
            <p className="error-message">{errors.mobilenumber}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="WhatsApp Number"
            name="whatsappnumber"
            value={whatsappnumber}
            onChange={(e) => setWhatsappNumber(e.target.value)}
          />
        </div>
      </div>
      <div className="col-xl-12">
        <div className="faq-page__single">
          <div
            className="accrodion-grp faq-one-accrodion"
            data-grp-name="faq-one-accrodion-1"
          >
            <div
              className={`accrodion ${
                openAccordion === "permanent" && "active"
              }`}
            >
              <div
                className="accrodion-title"
                onClick={() => toggleAccordion("permanent")}
              >
                <h4>Permanent Address</h4>
              </div>
              <div
                className="accrodion-content"
                style={{
                  marginTop: openAccordion !== "permanent" ? "-11px" : "-6px",
                }}
              >
                <div className="inner">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="country"
                          className={`become-volunteer__select ${
                            errors.country && "error-border"
                          }`}
                          defaultValue=""
                          value={country}
                          onChange={(e) => {
                            setCountry(e.target.value);
                            setStateProvince("");
                            setCity("");
                          }}
                        >
                          <option value="" disabled>
                            Country*
                          </option>
                          {Object.entries(countryDetails).map(
                            ([key, value]) => (
                              <option key={key} value={value.name}>
                                {value.name}
                              </option>
                            ),
                          )}
                        </select>
                        {errors.country && (
                          <p className="error-message">{errors.country}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="stateprovince"
                          className={`become-volunteer__select ${
                            errors.stateProvince && "error-border"
                          }`}
                          defaultValue=""
                          value={stateProvince}
                          onChange={(e) => {
                            setStateProvince(e.target.value);
                            setCity("");
                          }}
                        >
                          <option value="" disabled>
                            State/Province*
                          </option>
                          {!country && (
                            <option disabled>Select a country first</option>
                          )}

                          {country &&
                            Object.entries(countryDetails)
                              .filter(([_, value]) => value.name === country)
                              .flatMap(([key, value]) => {
                                const stateNames = Object.keys(
                                  value.states || {},
                                );
                                return stateNames.map((state, idx) => (
                                  <option key={`${key}-${idx}`} value={state}>
                                    {state}
                                  </option>
                                ));
                              })}
                        </select>
                        {errors.stateProvince && (
                          <p className="error-message">
                            {errors.stateProvince}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="city"
                          className={`become-volunteer__select ${
                            errors.city ? "error-border" : ""
                          }`}
                          defaultValue=""
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        >
                          <option value="" disabled>
                            City*
                          </option>
                          {!stateProvince && (
                            <option disabled>
                              Select a state/province first
                            </option>
                          )}

                          {stateProvince &&
                            Object.entries(countryDetails).flatMap(
                              ([countryKey, countryValue]) => {
                                const states = countryValue.states || {};

                                return Object.entries(states)
                                  .filter(
                                    ([stateKey]) => stateKey === stateProvince,
                                  )
                                  .flatMap(([stateKey, cityArray]) => {
                                    if (
                                      !Array.isArray(cityArray) ||
                                      cityArray.length === 0
                                    )
                                      return [];

                                    return cityArray.map(
                                      (cityObj: any, idx: number) => (
                                        <option
                                          key={`${stateKey}-${idx}`}
                                          value={cityObj.name}
                                        >
                                          {cityObj.name}
                                        </option>
                                      ),
                                    );
                                  });
                              },
                            )}
                        </select>
                        {errors.city && (
                          <p className="error-message">{errors.city}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <input
                          type="number"
                          placeholder="Postal/Zip Code*"
                          name="postalzipcode"
                          value={postalZipCode || ""}
                          onChange={(e) =>
                            setPostalZipCode(Number(e.target.value))
                          }
                          className={errors.postalZipCode && "error-border"}
                        />
                        {errors.postalZipCode && (
                          <p className="error-message">
                            {errors.postalZipCode}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="become-volunteer__input">
                        <input
                          type="text"
                          placeholder="Permanent Address*"
                          name="permanentaddress"
                          value={permanentAddress}
                          onChange={(e) => setPermanentAddress(e.target.value)}
                          className={errors.permanentAddress && "error-border"}
                        />
                        {errors.permanentAddress && (
                          <p className="error-message">
                            {errors.permanentAddress}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-12">
        <div className="faq-page__single">
          <div
            className="accrodion-grp faq-one-accrodion"
            data-grp-name="faq-one-accrodion-1"
          >
            <div
              className={`accrodion ${openAccordion === "work" && "active"}`}
            >
              <div
                className="accrodion-title"
                onClick={() => toggleAccordion("work")}
              >
                <h4>Work Address</h4>
              </div>
              <div
                className="accrodion-content"
                style={{
                  marginTop: openAccordion !== "work" ? "-11px" : "-6px",
                }}
              >
                <div className="inner">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="country"
                          className="become-volunteer__select"
                          defaultValue=""
                          value={workCountry}
                          onChange={(e) => {
                            setWorkCountry(e.target.value);
                            setWorkStateProvince("");
                            setWorkCity("");
                          }}
                        >
                          <option value="" disabled>
                            Country
                          </option>
                          {Object.entries(countryDetails).map(
                            ([key, value]) => (
                              <option key={key} value={value.name}>
                                {value.name}
                              </option>
                            ),
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="stateprovince"
                          className="become-volunteer__select"
                          defaultValue=""
                          value={workStateProvince}
                          onChange={(e) => {
                            setWorkStateProvince(e.target.value);
                            setWorkCity("");
                          }}
                        >
                          <option value="" disabled>
                            State/Province
                          </option>
                          {!workCountry && (
                            <option disabled>Select a country first</option>
                          )}

                          {workCountry &&
                            Object.entries(countryDetails)
                              .filter(
                                ([_, value]) => value.name === workCountry,
                              )
                              .flatMap(([key, value]) => {
                                const stateNames = Object.keys(
                                  value.states || {},
                                );
                                return stateNames.map((state, idx) => (
                                  <option key={`${key}-${idx}`} value={state}>
                                    {state}
                                  </option>
                                ));
                              })}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <select
                          name="city"
                          className="become-volunteer__select"
                          defaultValue=""
                          value={workCity}
                          onChange={(e) => setWorkCity(e.target.value)}
                        >
                          <option value="" disabled>
                            City
                          </option>
                          {!workStateProvince && (
                            <option disabled>
                              Select a state/province first
                            </option>
                          )}

                          {workStateProvince &&
                            Object.entries(countryDetails).flatMap(
                              ([countryKey, countryValue]) => {
                                const states = countryValue.states || {};

                                return Object.entries(states)
                                  .filter(
                                    ([stateKey]) =>
                                      stateKey === workStateProvince,
                                  )
                                  .flatMap(([stateKey, cityArray]) => {
                                    if (
                                      !Array.isArray(cityArray) ||
                                      cityArray.length === 0
                                    )
                                      return [];

                                    return cityArray.map(
                                      (cityObj: any, idx: number) => (
                                        <option
                                          key={`${stateKey}-${idx}`}
                                          value={cityObj.name}
                                        >
                                          {cityObj.name}
                                        </option>
                                      ),
                                    );
                                  });
                              },
                            )}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <input
                          type="number"
                          placeholder="Postal/Zip Code"
                          name="postalzipcode"
                          value={workPostalZipCode || ""}
                          onChange={(e) =>
                            setWorkPostalZipCode(Number(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="become-volunteer__input">
                        <input
                          type="text"
                          placeholder="Work Address"
                          name="workaddress"
                          value={workAddress}
                          onChange={(e) => setWorkAddress(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default ContactInformation;
